import {
  getDbOrThrow,
  DEFAULT_CAP,
  normalizeEmail,
  subscribeByEmail,
  assertCollectionName,
  col,
  mapRawDocs, // preserve legacy behavior: return mapped docs, not raw snaps
} from "./firestoreCore";
import { getDocs, query, where, limit } from "firebase/firestore";

/**
 * fetchByEmailOnce
 * - Keeps legacy default cap = DEFAULT_CAP
 * - Returns **mapped docs** (same as old dataFetchers implementation)
 */
export async function fetchByEmailOnce(
  colName,
  userEmail,
  { cap = DEFAULT_CAP, extra = [] } = {}
) {
  const db = getDbOrThrow();
  const email = normalizeEmail(userEmail);
  assertCollectionName(colName);
  if (!email) throw new Error("fetchByEmailOnce: missing userEmail");

  const base = col(db, colName);
  const qy = query(base, where("userEmail", "==", email), ...(extra || []), limit(cap));
  const snap = await getDocs(qy);
  return mapRawDocs(snap);
}

/**
 * subscribeByEmailHelper
 * - Unchanged behavior, thin wrapper around subscribeByEmail
 */
export function subscribeByEmailHelper({
  colName,
  userEmail,
  cap,
  extra = [],
  onData,
  onError,
}) {
  const db = getDbOrThrow();
  assertCollectionName(colName);
  return subscribeByEmail({
    colRef: col(db, colName),
    userEmail,
    cap,
    extra,
    onData,
    onError,
  });
}
